import { Typography } from 'antd';
import styled from 'styled-components';
import { DEVICES } from './breakpoint';

export const StylePageTitle = styled(Typography.Title)`
&& {
  margin-bottom: 20px;
  color: #5f6369;
  font-size: 24px;

  ${DEVICES.desktop} {
    font-size: 36px;
  }
}
`;

export const StylePageSubtitle = styled(Typography.Text)`
  display: block;
  font-size: 16px;
  font-weight: 300;
  margin-top: 20px;

  ${DEVICES.desktop} {
    font-size: 18px;
  }
`;
